import { recordTypes } from "../../../../API/config";
import { getDefaultCondtions } from "./defaultConditions";

export const defaultPermissionsofRules = (
  entityCategories,
  entitySubCategories,
  geographiesData,
  countriesData,
  allProcessSequence
) => {
  let defaultState = {};
  for (let rt in recordTypes) {
    //initialising recordtype
    defaultState[rt] = {};

    const actions = Object.keys(recordTypes[rt].actions)
      .map((a) => recordTypes[rt].actions[a])
      .filter((a) => !a.internal && !a.legacy);
    //adding all possible set of actions
    for (let index = 0; index < actions.length; index++) {
      const action = actions[index];
      defaultState[rt][action.name] = {
        accessStatus: false,
        conditions: getDefaultCondtions(
          entityCategories,
          entitySubCategories,
          geographiesData,
          countriesData,
          allProcessSequence
        ),
      };
    }
  }

  return defaultState;
};
